
import { Component, Vue, Prop } from 'vue-property-decorator';
import { downloadPdfFromBase64 } from '@/utils/files';
import { PublishedCampaign } from '@/types/campaigns';
import { Action } from 'vuex-class';
import namespaces from '@/store/namespaces';
import { DownloadCampaignInvoice } from '@/store/modules/campaign/types';

@Component({})
export default class DownloadInvoice extends Vue {
  @Prop({ required: true }) public campaign!: PublishedCampaign;

  @Action('downloadCampaignInvoice', { namespace: namespaces.CampaignModule })
  public downloadCampaignInvoice!: DownloadCampaignInvoice;

  public loading = 0;

  public async downloadInvoice() {
    const intervalId = setInterval(() => (this.loading += 1), 300); // completes in 30 sec

    try {
      const pdf = await this.downloadCampaignInvoice(this.campaign);

      const blob = downloadPdfFromBase64(
        pdf,
        `${this.campaign.INVOICE_NUMBER}.pdf`
      );

      this.loading = 100;
      setTimeout(() => {
        clearInterval(intervalId);
        this.loading = 0;
      }, 1000);

      /** Open file in current window */
      // const fileURL = URL.createObjectURL(blob);
      // window.location.href = fileURL;
    } catch (err) {
      clearInterval(intervalId);
      this.loading = 0;
      /* tslint:disable-next-line */
      console.log(err);
    }
  }
}
